export enum TipoAuditoria {
    INSERCAO = "INSERÇÃO",
    ATUALIZACAO = "ATUALIZAÇÃO",
    DELECAO = "DELEÇÃO"
   
}